export default {
  name: 'tapered-content-box',
  path: 'M0,0 L0.991,0 Q1,0,1,0.023 L0.945,0.823 Q0.934,1,0.871,1 L0,1 L0,0',
};
